import React from 'react'

const ArrowLeft = ({ color = '#DC7B19', size = '5' }) => {
  return (
    <svg
      className={`h-${size} w-${size}`}
      fill={color}
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.333 14.3198C23.333 14.7628 23.0038 15.1289 22.5767 15.1868L22.458 15.1948L4.95801 15.1948C4.47476 15.1948 4.08301 14.8031 4.08301 14.3198C4.08301 13.8768 4.41219 13.5108 4.83927 13.4528L4.95801 13.4448L22.458 13.4448C22.9413 13.4448 23.333 13.8366 23.333 14.3198Z"
        fill={color}
      />
      <path
        d="M12.6335 20.7281C12.9759 21.0691 12.9771 21.6231 12.6362 21.9656C12.3262 22.2769 11.8401 22.3062 11.497 22.0527L11.3987 21.9682L4.34039 14.9402C4.02815 14.6293 3.99975 14.1415 4.25519 13.7984L4.34034 13.7002L11.3987 6.67102C11.7411 6.33002 12.2951 6.33116 12.6361 6.67358C12.9461 6.98487 12.9733 7.47103 12.7185 7.81305L12.6335 7.91101L6.19818 14.3205L12.6335 20.7281Z"
        fill={color}
      />
    </svg>
  )
}

export default ArrowLeft
